/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.combos.create.configure.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.helpers',
  'acme.view.application.programs.combos.create.configure.addModal.controllers'
])

.controller('ProgramsCombosCreateConfigureController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'CalendarService', 'HelpersService', 'EventTemplatesData', 'AddonsData', function($scope, $state, $uibModal, $timeout, ApiService, CalendarService, HelpersService, EventTemplatesData, AddonsData) {

    $scope.programsCombosCreateConfigure = {

      isSubmitted: false,

      selectedAddon: '',
      selectedTemplate: '',
      selectedDiscount: '',
      selectedComboType: 'fixedPrice',
      selectedAddons: [],
      selectedTemplates: [],
      selectedTemplatesPercent: [],
      selectedTemplateSchedules: [],
      selectedTemplatesQuantity: [],

      selectedSchedule: [],
      selectedPriceList: {},

      addons: [],
      discounts: [],
      templates: [],
      comboAddons: [],
      comboTemplates: [],
      comboAnyTemplates: [],

      combo: null,
      selectedTemplatesTotalPercent: '0%',
      selectedDiscountPriceSplit: {},

      addOnQuantityOptions: [
        {
          name: 'Any amount',
          type: 'any'
        },
        {
          name: 'Exactly',
          type: 'exactly'
        }
      ],

      priceSplitOptions: [
        {
          name: 'Each',
          type: 'each'
        },
        {
          name: 'Total',
          type: 'total'
        }
      ],

      model: {
        salesChannels: [
          {
            name: 'online',
            enabled: true
          },
          {
            name: 'pos',
            enabled: true
          },
          {
            name: 'reseller',
            enabled: true
          }
        ]
      },

      init: function() {
        var title,
            titleLabel = 'Create Combo Details';

        $scope.$on("ProgramsCombosCreateController::save", this.onSave);

        if (EventTemplatesData && EventTemplatesData.data.success) {
          this.success.initTemplates(EventTemplatesData);
        }else{
          this.error.initTemplates(EventTemplatesData);
        }

        if (AddonsData && AddonsData.data.success) {
          this.success.initAddons(AddonsData);
        }else{
          this.error.initAddons(AddonsData);
        }

        if ($state.params && $state.params.comboId) {
          this.getCombo($state.params.comboId);
          titleLabel = 'Edit Combo Details';
        }else{
          this.initCombos();
        }
        
        title = {
          title: titleLabel,
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $state.go('application.programs.combos.list');
            }
          },
          buttonRight: {
            label: 'Save & Close',
            action: function() {
              $scope.programsCombosCreateConfigure.complete(true);
            }
          }
        };

        this.initDiscounts();
        $scope.$emit('Application::contentTitleChange', title);
      },

      initCombos: function() {
        this.addComboAddon();
        this.addComboTemplate();
      },

      initDiscounts: function() {
        ApiService.discounts.list('v2', HelpersService.getPaginator()).then(this.success.initDiscounts, this.error.initDiscounts);
      },

      onSave: function(e, data) {
        var self = $scope.programsCombosCreateConfigure;
        self.next = data.state;
        self.complete();
      },

      complete : function(close) {

        var errorHandler = (close) ? this.error.saveAndClose : this.error.complete,
            successHandler = (close) ? this.success.saveAndClose : this.success.complete;

        $scope.$emit('ProgramsCombosCreateController::reset');
        this.isSubmitted = true;

        if (this.isValid()) {
          if (this.combo && this.combo.id) {
            ApiService.combo.templates.update(this.marshal.toJSON()).then(successHandler, errorHandler);
          } else {
            ApiService.combo.templates.create(this.marshal.toJSON()).then(successHandler, errorHandler);
          }
        }else{
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  'Please correct the errors below.'
          });
        }
      },

      getCombo : function(id) {
        ApiService.combo.templates.get(id).then(this.success.getCombo, this.error.getCombo);
      },

      getScheduleIndex : function(templateIndex, scheduleId) {
        var self = this, scheduleMax, scheduleIndex;
        console.log('ProgramsCombosCreateConfigureController::getScheduleIndex', templateIndex, scheduleId );

        if (scheduleId) {
          scheduleMax = self.selectedTemplateSchedules[templateIndex].length;
          for (scheduleIndex = 0; scheduleIndex < scheduleMax; scheduleIndex++) {
            if (self.selectedTemplateSchedules[templateIndex][scheduleIndex].id === scheduleId) {
              console.log('ProgramsCombosCreateConfigureController::getScheduleIndex returning', scheduleIndex);
              return scheduleIndex;
            }
          }
        }
        return 0;
      },

      getTemplate: function(id, templateIndex, scheduleId) {

        var self = this;
        console.log('ProgramsCombosCreateConfigureController::getTemplate', id, templateIndex, scheduleId );

        ApiService.program.get(id).then(function(response) {

          self.selectedTemplates[templateIndex].template = angular.copy(response.data.payload);
          self.selectedTemplates[templateIndex].template.schedules.unshift({
            name: 'All schedules'
          });
          self.selectedTemplateSchedules[templateIndex] = self.selectedTemplates[templateIndex].template.schedules.slice(0);

          self.selectedSchedule[templateIndex] = self.selectedTemplateSchedules[templateIndex][self.getScheduleIndex(templateIndex, scheduleId)];

          self.selectedTemplatesQuantity[templateIndex] = self.selectedTemplatesQuantity[templateIndex] || 1;
          self.selectedTemplatesPercent[templateIndex] = self.selectedTemplatesPercent[templateIndex] || '100%';

          self.calculateTotalPercent();
          self.success.getTemplate(response);
        }, this.error.getTemplate);

      },

      hasComboTemplates: function() {
        return (this.comboTemplates.length > 0);
      },

      hasSelectedTemplates: function() {
        var i, ii,
            r = false;

        // Verify there is at least 1 valid event template
        if (this.selectedTemplates instanceof Array) {
          for (i=0,ii=this.selectedTemplates.length;i<ii;i++) {
            if (this.selectedTemplates[i]) {
              r = true;
              break;
            }
          }
        }

        return r;
      },

      hasComboAddons: function() {
        return (this.comboAddons.length > 0);
      },

      hasSelectedAddons: function() {
        var i, ii,
            r = false;
        // Verify there is at least 1 valid addon
        if (this.selectedAddons instanceof Array) {
          for (i=0,ii=this.selectedAddons.length;i<ii;i++) {
            if (this.selectedAddons[i].addon) {
              r = true;
              break;
            }
          }
        }

        return r;
      },

      hasDiscounts: function() {
        return (this.discounts.length > 0);
      },

      isComboType: function(type, combo) {
        return (combo.type === type);
      },

      hasValidAddOns: function() {

        var r = true;

        if (this.isSubmitted) {
          if (this.hasSelectedAddons()) {
            r = this.hasSelectedTemplates();
          }
        }

        return r;
      },

      isValidTotalPercent: function() {
        var r = true;

        if (this.isSubmitted && this.showAllocation()) {
          r = (parseFloat(this.selectedTemplatesTotalPercent) === 100);
        }

        return r;
      },

      isValidPricing: function() {
        var r = true;

        if (this.isSubmitted) {
          if (this.selectedComboType === 'fixedPrice') {
            r = (this.selectedPriceList && this.selectedPriceList.id);
          } else if (this.selectedComboType === 'discountCode') {
            r = (this.selectedDiscount && this.selectedDiscount.id);
          }
        }

        return r;
      },

      isValid: function() {
        return (this.isValidTotalPercent() &&
                this.isValidPricing() &&
                this.hasValidAddOns());
      },

      findEventTemplate: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.templates.length;i<ii;i++) {
          if (this.templates[i].id && this.templates[i].id === id) {
            r = this.templates[i];
            break;
          }
        }

        return r;
      },

      findDiscount: function(id) {

        var i, ii,
            r = false;

        if (this.hasDiscounts()) {
          for (i=0,ii=this.discounts.length;i<ii;i++) {
            if (id === this.discounts[i].id) {
              r = {
                index: i,
                discount: this.discounts[i]
              };
              break;
            }
          }
        }

        console.log('ProgramsCombosCreateConfigureController::findDiscount', r);
        return r;

      },

      findPriceSplit: function(type) {

        var i, ii,
            r = false;

        for (i=0,ii=this.priceSplitOptions.length;i<ii;i++) {
          if (type === this.priceSplitOptions[i].type) {
            r = {
              index: i,
              priceSplit: this.priceSplitOptions[i]
            };
            break;
          }
        }

        console.log('ProgramsCombosCreateConfigureController::findPriceSplit', r);
        return r;

      },

      showAddModal: function(templateIndex) {

        var self = this,
            selectedTemplatesList = self.comboAnyTemplates[templateIndex];

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/programs/combos/create/configure/modals/addComboEvent.tpl.html',
          size: 'md',
          controller: 'ProgramsCombosCreateConfigureAddModalController',
          resolve: {
            templatesList: function() {
              return self.templates.slice(1);
            },
            selectedTemplatesList: function() {
              return selectedTemplatesList;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (selectedTemplates) {
          $scope.$emit('ProgramsCombosCreateController::reset');

          self.isRemoving = true;
          console.log('ProgramsCombosCreateConfigureController::showAddModal', selectedTemplates);

          self.addSelectedTemplates(templateIndex, selectedTemplates);

        }, function () {
          // Do nothing
        });

      },

      addSelectedTemplates: function(templateIndex, selectedTemplates) {
        var id,
            template,
            comboAnyTemplates = [];

        for (id in selectedTemplates) {
          if (selectedTemplates.hasOwnProperty(id)) {
            if (selectedTemplates[id] === true) {
              template = this.findEventTemplate(id);
              if (template !== false) {
                comboAnyTemplates.push(template);
              }
            }
          }
        }

        console.log('ProgramsCombosCreateConfigureController::addSelectedTemplates', comboAnyTemplates);
        this.comboAnyTemplates[templateIndex] = comboAnyTemplates;
      },

      addComboAddon: function(addon) {
        var combo = {
              type: 'addon'
            },
            price = 0;

        if (addon) {
          combo.addon = addon;
          price = addon.price;
        }else{
          combo.type = 'new';
        }

        this.comboAddons.push(combo);
        this.selectedAddons.push({
          addon: addon,
          quantity: 1,
          quantityType: this.addOnQuantityOptions[0],
          price: price,
          priceSplit: this.priceSplitOptions[0]
        });
      },

      removeComboAddon: function(index) {
        this.selectedAddons.splice(index, 1);
        this.comboAddons.splice(index, 1);
      },

      addComboTemplate: function(type, event) {

        var combo = {
              type: type
            };

        if (type === 'any') {
          combo.quantity = 1;
          combo.events = [];
        }else if (type === 'event') {
          combo.event = event;
        }else{
          combo = {
            type: 'new'
          };
        }

        this.comboTemplates.push(combo);
      },

      removeComboTemplate: function(index) {
        this.selectedTemplates.splice(index, 1);
        this.selectedSchedule.splice(index, 1);
        this.selectedTemplateSchedules.splice(index, 1);
        this.selectedTemplatesPercent.splice(index, 1);
        this.selectedTemplatesQuantity.splice(index, 1);
        this.comboAnyTemplates.splice(index, this.comboAnyTemplates.length);
        this.comboTemplates.splice(index, 1);
        this.calculateTotalPercent();
      },

      addComboAnyTemplate: function(comboItemIndex) {
        console.log('ProgramsCombosCreateConfigureController::addComboAnyTemplate', comboItemIndex);
        this.comboAnyTemplates[comboItemIndex].push({
          name: false
        });
      },

      removeComboAnyTemplate: function(comboItemIndex, index) {
        this.comboAnyTemplates[comboItemIndex].splice(index, 1);
      },

      updateComboAddon: function(combo, addon, addonIndex) {

        var self = this,
            selected = this.selectedAddons[addonIndex];
        console.log('ProgramsCombosCreateConfigureController::updateComboAddon', combo, addon);

        $timeout(function() {
          if (!selected) {
            // Nothing selected
            combo.type = 'new';
          }else{
            combo.type = 'addon';
          }
          console.log('ProgramsCombosCreateConfigureController::updateComboAddon', combo, addon);
        }, 10);

      },

      convertToPercent: function(index) {
        var n = parseFloat(this.selectedTemplatesPercent[index]);

        if (!isNaN(n)) {
          n = n + '%';
        }else{
          n = '0%';
        }

        this.selectedTemplatesPercent[index] = n;
        this.calculateTotalPercent();
      },

      convertAddOnPriceToCurrency: function(index) {
        var price = 0;

        if (this.selectedAddons[index] && this.selectedAddons[index].addon) {
          price = HelpersService.currencyFloatToInteger(this.selectedAddons[index].addon.price);
          console.log('ProgramsCombosCreateConfigureController::convertAddOnPriceToCurrency', price, HelpersService.integerToCurrencyFloat(price));
          this.selectedAddons[index].addon.price = HelpersService.integerToCurrencyFloat(price, 2, true);
        }

      },

      calculateTotalPercent: function() {
        var i, ii,
            total = 0,
            percent = 0;

        for (i=0,ii=this.selectedTemplatesPercent.length;i<ii;i++) {
          // Make sure we have a selected template
          if (this.selectedTemplates[i]) {
            percent = parseFloat(this.selectedTemplatesPercent[i]);
            if (!isNaN(percent)) {
              total += percent;
            }
          }
        }

        this.selectedTemplatesTotalPercent = total + '%';

      },

      updateComboTemplate: function(combo, templateIndex, scheduleId) {

        var self = this,
            template = this.selectedTemplates[templateIndex];

        // Wait for on change event to propagate to models
        $timeout(function() {
          if (!template) {
            // Nothing selected
            combo.type = 'new';
            self.selectedTemplatesPercent[templateIndex] = self.selectedTemplatesPercent[templateIndex] || '0%';
            self.calculateTotalPercent();
          }else {
            if (template.name === 'Any') {
              // Any event selected
              combo.type = 'any';
              if (!(self.comboAnyTemplates[templateIndex] instanceof Array)) {
                self.comboAnyTemplates[templateIndex] = [];
                self.comboAnyTemplates[templateIndex].push({
                  name: false
                });
                self.selectedTemplatesQuantity[templateIndex] = self.selectedTemplatesQuantity[templateIndex] || 1;
                self.selectedTemplatesPercent[templateIndex] = self.selectedTemplatesPercent[templateIndex] || '100%';
                self.calculateTotalPercent();
              }
            } else {
              combo.type = 'event';
              console.log('ProgramsCombosCreateConfigureController::updateComboTemplate', combo, template);
              self.getTemplate(template.id, templateIndex, scheduleId);
            }
          }

        }, 10);

      },

      allowComboAdd: function(index) {
        return (this.comboTemplates.length - 1 === index);
      },

      allowComboRemove: function() {
        return (this.comboTemplates.length > 1);
      },

      allowAddonAdd: function(index) {
        return (this.comboAddons.length - 1 === index);
      },

      allowAddonRemove: function() {
        return (this.comboAddons.length > 1);
      },

      allowComboAnyAdd: function(comboItemIndex, index) {
        console.log('ProgramsCombosCreateConfigureController::allowComboAnyAdd', comboItemIndex, index);
        return (this.comboAnyTemplates[comboItemIndex].length - 1 === index);
      },

      allowComboAnyRemove: function(comboItemIndex) {
        return (this.comboAnyTemplates[comboItemIndex].length > 1);
      },

      showAllocation: function() {
        return (this.selectedComboType === 'fixedPrice' || this.selectedDiscountPriceSplit.type === 'total');
      },

      setAddonPriceSplit: function(index) {
        if (this.selectedAddons[index].quantityType.type === 'any') {
          this.selectedAddons[index].priceSplit = this.priceSplitOptions[0];
        }
      },

      getQuantityType: function(quantityType) {
        var self = $scope.programsCombosCreateConfigure,
          i, n;

        n = self.addOnQuantityOptions.length;

        for (i = 0; i < n; i++) {
          if (self.addOnQuantityOptions[i].type === quantityType) {
            return self.addOnQuantityOptions[i];
          }
        }
        return self.addOnQuantityOptions[0];
      },

      getPriceSplit : function(priceSplit) {
        var self = $scope.programsCombosCreateConfigure,
          i, n;

        n = self.priceSplitOptions.length;

        for (i = 0; i < n; i++) {
          if (self.priceSplitOptions[i].type === priceSplit) {
            return self.priceSplitOptions[i];
          }
        }
        return self.priceSplitOptions[0];
      },

      getTemplateById : function(templateId) {
        var self = $scope.programsCombosCreateConfigure,
          i, n;
        if (self.templates) {
          n = self.templates.length;

          for (i = 0; i < n; i++) {
            if (self.templates[i].id === templateId) {
              return self.templates[i];
            }
          }
        }
        return null;
      },

      success: {
        init: function(response) {},

        initAddons: function(response) {
          var self = $scope.programsCombosCreateConfigure;
          self.addons = response.data.payload.list;
        },

        initTemplates: function(response) {
          var self = $scope.programsCombosCreateConfigure,
              templates = [{
                name: 'Any'
              }];
          self.templates = templates.concat(response.data.payload.list);
        },

        initDiscounts: function(response) {
          var self = $scope.programsCombosCreateConfigure;
          self.discounts = response.data.payload.list;

          if (self.combo && self.combo.discountId) {
            self.selectedDiscount = self.discounts[self.findDiscount(self.combo.discountId).index];
          }
        },

        getTemplate: function(response) {
          // Handled inline
        },

        getCombo: function(response) {
          var self = $scope.programsCombosCreateConfigure;

          self.marshal.fromJSON(response.data.payload);
        },

        complete: function(response) {
          var self = $scope.programsCombosCreateConfigure;

          self.isSubmitted = false;

          if (self.next) {
            $state.go(self.next, { comboId: response.data.payload.id });
          }
        },

        saveAndClose: function(response) {
          $scope.programsCombosCreateConfigure.isSubmitted = false;

          $scope.$emit('ProgramsCombosCreateController::success', {
            message: 'Successfully Saved!'
          });

          $scope.$emit('ProgramsCombosCreateController::transition', {
            state: 'application.programs.combos.list'
          });
        }
      },

      error: {
        init: function(response) {},
        initAddons: function(response) {},
        initTemplates: function(response) {},
        initDiscounts: function(response) {},
        getTemplate: function(response) {},
        getCombo: function(response) {},
        complete: function(response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        },
        saveAndClose: function(response) {
          $scope.$emit('ProgramsCombosCreateController::error', {
            message:  response.data.error
          });
        }
      },

      onSelectedAddonUpdate: function(n, o) {
        console.log('ProgramsCombosCreateConfigureController::onSelectedAddonUpdate', n);
        $scope.programsCombosCreateConfigure.updateComboAddon(n);
      },

      onSelectedTemplateUpdate: function(n, o) {
        console.log('ProgramsCombosCreateConfigureController::onSelectedTemplateUpdate', n);
        $scope.programsCombosCreateConfigure.updateComboTemplate(n);
      },

      marshal : {
        toJSON : function() {
          var self = $scope.programsCombosCreateConfigure;

          if (self.combo) {

            self.combo.startTime = CalendarService.toISO8601(self.combo.startTime);
            self.combo.endTime = CalendarService.toISO8601(self.combo.endTime);
            self.marshal.salesChannels.toJSON();
            self.marshal.addOns.toJSON();
            self.marshal.templates.toJSON();
            self.combo.type = self.selectedComboType;
            self.combo.discountDistributionType = self.findPriceSplit(self.selectedDiscountPriceSplit.type).priceSplit.type;

            if (self.combo.type === 'fixedPrice') {
              self.combo.priceList = self.selectedPriceList;
              self.combo.discountId = null;
            }else {
              self.combo.discountId = self.selectedDiscount.id;
              self.combo.priceList = null;
            }
          } else {
            self.combo = {
              startTime: CalendarService.toISO8601(new Date()),
              endTime: CalendarService.toISO8601(new Date())
            };
          }

          return self.combo;
        },

        fromJSON : function(json) {
          console.log('ProgramsCombosCreateConfigureController::marshal::fromJSON', json);
          var i, ii,
              self = $scope.programsCombosCreateConfigure;

          self.combo = json;
          self.marshal.salesChannels.fromJSON(json);
          self.marshal.addOns.fromJSON(json);
          self.marshal.templates.fromJSON(json);
          self.selectedComboType = self.combo.type;
          self.selectedPriceList = self.combo.priceList;
          if (self.combo.discountId) {
            self.selectedDiscount = self.discounts[self.findDiscount(self.combo.discountId).index];
          }
          if (self.combo.discountDistributionType) {
            self.selectedDiscountPriceSplit = self.findPriceSplit(self.combo.discountDistributionType).priceSplit;
          }else {
            self.selectedDiscountPriceSplit = self.priceSplitOptions[0];
          }
        },

        salesChannels : {
          toJSON : function() {
            var self = $scope.programsCombosCreateConfigure;
            var i,
              n = self.model.salesChannels.length;
            self.combo.salesChannels = [];

            for (i = 0; i < n; i++) {
              self.combo.salesChannels.push({
                channel : self.model.salesChannels[i].name,
                enabled : self.model.salesChannels[i].enabled
              });
            }
          },

          fromJSON : function(json) {
            if (json.salesChannels) {
              var self = $scope.programsCombosCreateConfigure;
              var i,
                ii,
                n = json.salesChannels.length,
                nn = self.model.salesChannels.length,
                sourceSalesChannelName;

              for (i = 0; i < n; i++) {
                sourceSalesChannelName = json.salesChannels[i].channel;
                for (ii = 0; ii < nn; ii++) {
                  if (self.model.salesChannels[ii].name === sourceSalesChannelName) {
                    self.model.salesChannels[ii].enabled = json.salesChannels[i].enabled;
                  }
                }
              }
            }
          }
        },

        addOns : {
          toJSON : function() {
            var self = $scope.programsCombosCreateConfigure,
              i, n;

            self.combo.addOns = [];

            if (self.selectedAddons) {
              n = self.selectedAddons.length;

              for (i = 0; i < n; i++) {
                if (self.selectedAddons[i].addon) {
                  self.combo.addOns.push({
                    id: self.selectedAddons[i].addon.id,
                    quantity: self.selectedAddons[i].quantity,
                    price: self.selectedAddons[i].addon.price,
                    quantityType: self.selectedAddons[i].quantityType.type,
                    priceSplit: self.selectedAddons[i].priceSplit.type
                  });
                }
              }
            }
          },

          fromJSON : function(json) {
            var self = $scope.programsCombosCreateConfigure,
              i, n,
              addOnIndex, addOnCount,
              currentAddOn,
              selectedAddOnIndex = 0;

            if (json.addOns instanceof Array && json.addOns.length > 0) {
              n = json.addOns.length;
              addOnCount = self.addons.length;

              for (i = 0; i < n; i++) {
                currentAddOn = json.addOns[i].addOnId;

                console.log('ProgramsCombosCreateConfigureController::marshal::addOns::fromJSON looking for', currentAddOn);

                for (addOnIndex = 0; addOnIndex < addOnCount; addOnIndex++) {
                  if (self.addons[addOnIndex].id === currentAddOn) {
                    console.log('ProgramsCombosCreateConfigureController::marshal::addOns::fromJSON found', currentAddOn, self.addons[addOnIndex]);
                    self.addComboAddon(self.addons[addOnIndex]);
                    selectedAddOnIndex = self.selectedAddons.length - 1;
                    self.selectedAddons[selectedAddOnIndex].quantity = json.addOns[i].quantity;
                    self.selectedAddons[selectedAddOnIndex].addon.price = json.addOns[i].price;
                    self.selectedAddons[selectedAddOnIndex].priceSplit = self.getPriceSplit(json.addOns[i].priceSplit);
                    self.selectedAddons[selectedAddOnIndex].quantityType = self.getQuantityType(json.addOns[i].quantityType);
                    break;
                  }
                }

              }
            }else{
              self.addComboAddon();
            }
          }
        },

        templates : {
          fromJSON : function(json) {
            var self = $scope.programsCombosCreateConfigure,
              i, n, currentTemplateId, templateIndex, templateCount;

            if (json.templates &&
                json.templates.entries instanceof Array &&
                json.templates.entries.length > 0) {
              n = json.templates.entries.length;
              templateCount = self.templates.length;
              for (i = 0; i < n; i++) {
                if (json.templates.entries[i].type === 'event') {
                  self.addComboTemplate('event');
                  currentTemplateId = json.templates.entries[i].templateId;

                  for (templateIndex = 0; templateIndex < templateCount; templateIndex++) {
                    if (self.templates[templateIndex].id === currentTemplateId) {
                      self.selectedTemplates[i] = self.templates[templateIndex];
                      self.updateComboTemplate(i, i, json.templates.entries[i].schedule);
                      break;
                    }
                  }
                } else {
                  var newList = [],
                    currentSourceTemplateId, maxSourceTemplateIds;
                  console.log('ProgramsCombosCreateConfigureController::marshal::templates.fromJSON any template', json.templates, i);

                  self.addComboTemplate('any');
                  self.selectedTemplates[i] = self.templates[0];
                  maxSourceTemplateIds = json.templates.entries[i].templateIds.length;

                  for (currentSourceTemplateId = 0; currentSourceTemplateId < maxSourceTemplateIds; currentSourceTemplateId++) {
                    newList.push(self.getTemplateById(json.templates.entries[i].templateIds[currentSourceTemplateId]));
                  }

                  if (self.comboAnyTemplates == null) {
                    self.comboAnyTemplates = [];
                  }
                  self.comboAnyTemplates[i] = newList;

                }

                self.selectedTemplatesPercent[i] = json.templates.entries[i].revenueAllocation;
                self.convertToPercent(i);
                self.selectedTemplatesQuantity[i] = json.templates.entries[i].quantity;
              }

            }else{
              self.addComboTemplate();

            }
          },

          toJSON : function() {
            var self = $scope.programsCombosCreateConfigure,
              i, n, newEntry,
              comboArray, currentAny, comboEntryIndex, comboEntryMax;

            self.combo.templates = {
              entries: []
            };

            if (self.comboTemplates) {
              n = self.comboTemplates.length;
              for (i = 0; i < n; i++) {
                if (self.isComboType('any', self.comboTemplates[i])) {
                  if (self.comboAnyTemplates && self.comboAnyTemplates.length > i) {
                    comboArray = [];
                    currentAny = self.comboAnyTemplates[i];
                    if (currentAny) {
                      comboEntryMax = currentAny.length;
                      for (comboEntryIndex = 0; comboEntryIndex < comboEntryMax; comboEntryIndex++) {
                        comboArray.push(currentAny[comboEntryIndex].id);
                      }

                      newEntry = {
                        templateIds: comboArray
                      };
                    }
                  }
                } else {
                  newEntry = {
                    templateId: self.selectedTemplates[i].id
                  };
                }

                newEntry['revenueAllocation'] = self.selectedTemplatesPercent[i];
                newEntry['quantity'] = self.selectedTemplatesQuantity[i];
                if (i < self.selectedSchedule.length && self.selectedSchedule[i]) {
                  newEntry['schedule'] = self.selectedSchedule[i].id;
                }

                if (newEntry) {
                  self.combo.templates.entries.push(newEntry);
                }
              }
            }
          }
        }
      }

    };

    $scope.programsCombosCreateConfigure.init();

}]);